import { Button } from '@mui/material';
import BaseTable from 'components/ui/tables/BaseTable';
import useTopPanel from 'hooks/useTopPanel';
import { memo, useEffect, useState } from 'react';

import SimpleSearchInput from 'components/SearchInputNavbar';
import { useNavigate, useParams } from 'react-router-dom';
import ProductHistory from './ProductHistory';

const Products = () => {
  const { setComponent } = useTopPanel();
  const { id } = useParams();
  const [refetch, setRefetch] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [open, setOpen] = useState(false);
  const [itemData, setItemData] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    setComponent(<div className='component-title'>Ombor tarixi</div>);
  }, []);

  const onUpdateIncome = (data) => {
    navigate(`/admin/warehouse/${id}/inbound/${data?.id}/update`);
  };

  return (
    <div className='component-list-wrapper'>
      <div className='component-list-header mb-2'>
        <div className='header-actions-container py-3 flex flex-row items-center'>
          <div className='header-actions filter-box flex items-center px-4 w-full'>
            <Button
              variant='base'
              color='primary'
              startIcon={<i className='bi bi-filter' />}
              className='!mr-2'
            >
              Filter
            </Button>
            <SimpleSearchInput inputKey='name' />
          </div>
          <div className='header-actions action-buttons-box py-3 px-4 flex gap-2 items-center justify-center'>
            <Button
              variant='base'
              color='info'
              onClick={() => {
                setRefetch(true);
              }}
              disable={`${refetch}`}
            >
              <i
                className={`bi bi-arrow-repeat${
                  refetch ? ' animate-spin' : ''
                }`}
              />
            </Button>
            <Button
              variant='base'
              color='default'
              onClick={() => setOpen(true)}
            >
              <i className='bi bi-gear' />
            </Button>
          </div>
        </div>
      </div>

      <div className='component-table-wrapper h-[calc(100vh-180px)]'>
        <BaseTable
          emitRefetch={{ refetch, setRefetch }}
          dataPath={`admin/warehouses/history/${id}`}
          emitTableColumns={{ open, setOpen }}
          tableName='admin/warehouses/history/'
          headCells={[
            { code: 'id', label: '#' },
            { code: 'user', label: 'Xodim' },
            { code: 'supplier', label: 'Yetkazuvchi' },
            { code: 'warehouse', label: 'Ombor' },
            { code: 'date', label: 'Sana' },
            { code: 'sum', label: 'Summa' },
            { code: 'valute', label: 'Valyuta' },
            { code: 'converted_amount', label: 'Sum Konvertatsiyasi' },
          ]}
          columns={[
            { code: 'id' },
            { code: 'user', type: 'nested', childStr: 'name' },
            { code: 'supplier', type: 'nested', childStr: 'name' },
            { code: 'warehouse', type: 'nested', childStr: 'name' },
            { code: 'date', type: 'date' },
            { code: 'sum', type: 'priceSum' },
            { code: 'valute', type: 'price' },
            { code: 'converted_amount', type: 'price' },
          ]}
          actionsList={[
            {
              icon: 'bi bi-eye',
              btnColor: 'info',
              setOpen: setOpenModal,
              setData: setItemData,
            },
            {
              icon: 'bi bi-pen',
              btnColor: 'warning',
              setOpen: () => {},
              setData: onUpdateIncome,
            },
          ]}
        />
      </div>
      {openModal && (
        <ProductHistory
          open={openModal}
          setOpen={setOpenModal}
          itemData={itemData}
          setItemData={setItemData}
          setRefetch={setRefetch}
        />
      )}
    </div>
  );
};

export default memo(Products);
